<template>
    <div>
        <div v-if="is_initialized">
            <span>
                <!-- 請上傳簽收單： -->
                {{ $t('ui.scanner.upload.receipt_file') }}：
            </span>
            <FileUploader
                class="file_uploader_tool"
                :channel="core_waybill_receipt_file_url_eventbus"
            >
            </FileUploader>
            <h3 v-if="file_uploader.message"
                class="file_uploader_message"
                >
                <!-- 上傳結果： -->
                {{ $t('ui.scanner.upload.result') }}：
                <span :class="file_uploader.status">
                    {{ file_uploader.message }}
                </span>
            </h3>
        </div>
    </div>
</template>

<script>
import FileUploader from "@toolbox/file_uploader/main.vue"

export default {
    components: {
        FileUploader,
    },
    props: {
        related_column: {
            default: {},
            input_type: Object
        },
        focus_input_name: {
            default: "",
            input_type: String
        },
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            current_column_order: 0,
            file_uploader: {
                status: "",
                message: "",
            },
            core_waybill_receipt_file_url_eventbus: "",
        }
    },
    computed: {
        current_store() {
            return this.$store.state.customer.scanner_module
        },
        actions_core_waybill_related_columns() {
            return this.current_store.actions_core_waybill_related_columns
        },
    },
    watch: {
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            try {
                await this.set_core_waybill_receipt_file_url()
                await new Promise(resolve => {
                    this.current_column_order = 0
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                console.log(e)
            }
        },
        set_core_waybill_receipt_file_url() {
            this.core_waybill_receipt_file_url_eventbus = `core_waybill_receipt_file_url_${this.current_store.current_core_waybill.number}`

            this.$bus.$off(this.core_waybill_receipt_file_url_eventbus)
            this.$bus.$on(this.core_waybill_receipt_file_url_eventbus, (from, eventname, url) => {
                switch (eventname) {
                    case "uploaded_file":
                        this.file_uploader.status = "await"
                        // this.file_uploader.message = "上傳中"
                        this.file_uploader.message = this.$t('ui.general.uploading')
                        break

                    case "uploading":
                        console.log("uploading")
                        this.file_uploader.status = "await"
                        // this.file_uploader.message = "上傳中"
                        this.file_uploader.message = this.$t('ui.general.uploading')
                        break

                    case "upload complete":
                        this.actions_core_waybill_related_columns[this.related_column.name] = url
                        this.file_uploader.status = "success"
                        this.file_uploader.message = this.$t('ui.notifications.success.update')
                        this.$bus.$emit('scanner_next_actions_core_waybill_related')
                        break

                    case "upload failed":
                        console.log("file_uploader failed")
                        this.file_uploader.status = "failure"
                        this.file_uploader.message = this.$t('ui.notifications.error.update')
                        break
                }
            })
        },
    },

}
</script>

<style lang="scss" scoped>
    .file_uploader_tool {
        & {
            display: inline-block;
            border-radius: 4px;
            background: #ffffff !important;
        }
    }

    .file_uploader_message {
        & {
            margin: 0;
            text-align: right;
        }
        .failure {
            color: red;
        }
        .success {
            color: #21ba45;
        }
    }
</style>
